module.exports = __webpack_public_path__ + "img/Soga-om-Gunnlaug-Ormstunge_Maleri-I-starten.732a05a1.jpg";